/**
 * Local dev/stg fallback deadhead list. Rendered only when the live
 * `deadheadSearch` query returns zero results AND the app is running on
 * dispatch-dev / dispatch-stg / localhost (see `utils/env`).
 *
 * Shape mirrors `gql/deadheadSearch.js`'s `results` shape
 * so the picker treats stubs identically to live rows (`crewMember.id`
 * matters for the payload mapper).
 *
 * Delete or narrow this list once real deadheads land on the dev backend.
 */

import { todayAtIso } from 'utils/datetime/fnsTimeFormatter';

const todayAt = (hour, minute = 0) => todayAtIso(hour, minute);

export const STUB_DEADHEADS = [
	{
		id: 'stub-dh-1001',
		busId: null,
		partnershipId: null,
		relatedRideId: null,
		rideNumber: '1001',
		departure: {
			address: 'GHDummy MA Breakdowns Only',
			timezone: 'America/New_York',
			stationDetails: { code: 'XMA6', name: 'GHDummy MA Breakdowns Only' },
			plannedTimestamp: todayAt(9, 30),
			actualTimestamp: null,
		},
		arrival: {
			address: 'Toronto',
			stationDetails: { code: 'TRN6', name: 'Toronto' },
			plannedTimestamp: todayAt(14, 0),
			actualTimestamp: null,
		},
		partnerId: null,
		mobilityPartner: null,
		plateNumber: null,
		busNumber: '86271',
		status: 'OK',
		type: '9997 - New bus delivery',
		crewMember: { id: 'stub-driver-1', fullName: 'Torf, Terry' },
	},
	{
		id: 'stub-dh-1002',
		busId: null,
		partnershipId: null,
		relatedRideId: null,
		rideNumber: '1002',
		departure: {
			address: 'GHDummy Boston Hub',
			timezone: 'America/New_York',
			stationDetails: { code: 'BOS1', name: 'GHDummy Boston Hub' },
			plannedTimestamp: todayAt(11, 0),
			actualTimestamp: null,
		},
		arrival: {
			address: 'New York Port Authority',
			stationDetails: { code: 'NYC', name: 'New York Port Authority' },
			plannedTimestamp: todayAt(15, 30),
			actualTimestamp: null,
		},
		partnerId: null,
		mobilityPartner: null,
		plateNumber: null,
		busNumber: '86896',
		status: 'OK',
		type: '9991 - Balance equipment',
		crewMember: { id: 'stub-driver-2', fullName: 'Adams, Renea' },
	},
	{
		id: 'stub-dh-1003',
		busId: null,
		partnershipId: null,
		relatedRideId: null,
		rideNumber: '1003',
		departure: {
			address: 'GHDummy Chicago Central',
			timezone: 'America/Chicago',
			stationDetails: { code: 'CHI3', name: 'GHDummy Chicago Central' },
			plannedTimestamp: todayAt(13, 15),
			actualTimestamp: null,
		},
		arrival: {
			address: 'Denver Union Station',
			stationDetails: { code: 'DNV6', name: 'Denver Union Station' },
			plannedTimestamp: todayAt(19, 0),
			actualTimestamp: null,
		},
		partnerId: null,
		mobilityPartner: null,
		plateNumber: null,
		busNumber: '86918',
		status: 'OK',
		type: '9998 - Oper training school',
		crewMember: { id: 'stub-driver-3', fullName: 'Johnson, Mark' },
	},
];
